


























































































































































import Loading from 'vue-loading-overlay';
import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import {
    AuthStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    StoreHelper,
    VehicleCompanyStoreHelper
} from '../../core/mixins';
import { FilterDateEvent } from '../../core/utils/types';
import { formattedDate, getCurrentTimestamp, getDateFromDateFormatApi, getTimeOffset, goToUrl, NAME_ROUTES, PRIVILEGE_KEYS, PRIVILEGE_TYPES, sortObjectByPropertyName } from '../../core/utils';
import { TypeFilterDate } from '../../core/models/type-filter-date';
import { formatComplexList, formatList } from '../../core/utils/table-formatters';
import Axios from 'axios';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import { PageTitle } from '../../core/components';
import  Combobox from '../../core/components/Combobox.vue';
import  Button from '../../core/components/Button.vue';
import  Input from '../../core/components/Input.vue';
import  SectionTitle from '../../core/components/SectionTitle.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
// import ModalReportSuscription from '../components/ModalReportSuscription.vue';
import { ActiveReports, parameterSubscriptionIdQuantity, parameterTimeOffsetQuantity, ReportActivation, SuscriptionsList, Template, TemplateParamsOptions, unsuscribeReport } from '../../core/models/';
import { ReportsServices } from '../../reports/api/ReportsServices';
import { AuthEvent } from '../../../store';
import { ActiveOptions } from '../../../features/insurance/options';
import ModalReportRefresh from '../../reports/components/ModalReportRefresh.vue';

@Component({
    components: { 
        Loading, 
        PageTitle,
        SectionTitle,
        SimpleTable,
        Button,
        ModalReportRefresh,
        Combobox,
        DeleteConfirmation,
        Input
    }
})
export default class ReportsControlPage extends Mixins(
    StoreHelper,
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    NotificationStoreHelper,
    AuthStoreHelper
) {
    allCompanies: boolean = false;
    visibleModalDownloadExcel: boolean = false;
    visibleModalReportSuscription: boolean = false;
    itemsTable: Array<ActiveReports> = [];
    templatesList: Array<Template> = [];
    userSearch: string = '';
    headers: Array<object> = [
        {
            text: 'Tipo de Reporte',
            align: 'left',
            value: 'template_description',
            filter: this.filterByReportType,
            sortable: true,
            width: '320px'
        },
        {
            text: 'Empresa/s',
            align: 'left',
            value: 'company_name',
            sortable: true,
        },
        {
            text: 'Estado de activación',
            align: 'center',
            value: 'is_active',
            sortable: true,
            filter: this.filterByReportState,
            width: '180px'
        },
        {
            text: 'Fecha primer dato',
            align: 'center',
            value: 'first_data',
            formatter: (value)=> formattedDate(value, true),
            width: '213px'
        },
        {
            text: 'Fecha último dato',
            align: 'center',
            value: 'last_data',
            formatter: (value) => formattedDate(value, true),
            width: '213px'
        },        
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions',
            width: '150px'
        }
    ];
    pendingTemplates: boolean = false;
    confirmationDelete: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';
    templateIdToUnsuscribe: number = -1;
    reportTypesList: string[] = [];
    reportTypeSelected: object | null = null;
    filtersStateReportList: Array<object> = ActiveOptions;
    filterStateSelected: object | null = null;
    filtersStateRV: boolean = false;
    reportTypeSelectedRV: boolean = false;
    deactivateConfig: Array<ReportActivation> = [];
    rowToDeactivate: ActiveReports | null = null;
    deleteConsequences: string[] = ['Esta acción modificará todas las suscripciones que estan relacionadas']
    visibleModalRefresh: boolean = false;
    templateName: Template['template_name'] | null = null;


    get getPageTitle() {
        return `Gestión de Reportes - ${!this.allCompanies ? this.getCurrentCompany : ' Todas mis empresas'}`
    }

    get modalRefreshElement(): HTMLFormElement {
        return this.$refs.refreshReportModal as HTMLFormElement;
    }

    showRefreshModal(template: Template){
        let needToSelectDate = template.has_dayrange;
        this.templateName = template.template_name;

        if(!needToSelectDate){
            //refresh report directly
            this.modalRefreshElement.updateReport(
                null,
                this.templateName,
                true
            );
        }else{
            this.visibilityModalRefresh(true);
        }
    }

    closeRefreshModal(){
        this.visibilityModalRefresh(false);
    }

     visibilityModalRefresh(value: boolean){
        this.visibleModalRefresh = value;
    }

    updateUserSearch(value){
        this.userSearch = value;
    }

    userConfirmation(value: boolean){
        let rowToDeactivate = this.rowToDeactivate as ActiveReports
         if (value) {
           this.confirmationDelete = false;
           this.deactivateReport(this.deactivateConfig, rowToDeactivate);
        } else {
           this.$set(rowToDeactivate, 'is_active', true);
           this.confirmationDelete = false;
        }
    }

    filterByReportType(value) {
        return this.reportTypeSelected !== null ? value === this.reportTypeSelected['description'] : true;
    }

    filterByReportState(value) {
        return this.filterStateSelected !== null ? value === this.filterStateSelected['value'] : true;
    }


    updateFiltersStateRV(value){
        this.filtersStateRV = value;
    }

    updateFiltersSelected(value){
        this.filterStateSelected = value;
    }
    updateReportTypeSelected(value){
        this.reportTypeSelected = value;
    }
    updateFiltersReportTypeRV(value){
        this.reportTypeSelectedRV = value;
    }

    unsubscribe: () => void;

    created(){
        this.unsubscribe = this.$store.subscribe((mutation, stateList) => {
            if (mutation.type !== AuthEvent.SET_PRIVILEGES) return;
            this.checkPermissions();
        });
    }

    checkPermissions() {
        if (!this.shouldSeePanel) {
            this.$router.push(NAME_ROUTES.HOME.path);
        }
    }


    get shouldSeePanel(): boolean {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.REPORTS_PANEL, PRIVILEGE_TYPES.READ);
    }
        
    @Watch('$route', { immediate: true, deep: true })
    onUrlChange() {
        this.getActiveReports();
    }


    removeSuscriptionFromList(){
        let indexTemplateToRemove = this.itemsTable.findIndex(item => item['id'] === this.templateIdToUnsuscribe);
        if(indexTemplateToRemove !== -1){
            this.itemsTable.splice(indexTemplateToRemove, 1);
            this.$_showAddPointOfInterest('Suscripción removida')
        }
        this.templateIdToUnsuscribe = -1;
    }

    visibilityModalReportSuscription(value: boolean){
        
    }
    visibilityModalDownloadExcel(value: boolean){
        this.visibleModalDownloadExcel = value;
    }

    createReport(){
        // console.log("create report");
    }

    get getCurrentCompany(){
        return this.$_getCurrentCompanyName
    }

    setSuscriptions(items:  Array<ActiveReports>){
        this.itemsTable = items;
    }

    pendingRequest(value){
        this.pendingTemplates = value;
    }

    @Watch('$_getSelectedCompanyById')
    observableCompanyChange(){
        this.getActiveReports();
    } 

    getActiveReports(){
        // console.log("get suscripciones", currentCompanyId);
        let currentCompanyId = this.$_getSelectedCompanyById as string;
        this.pendingRequest(true);

        if(currentCompanyId){
            ReportsServices.getActiveReportsByCompany(
                currentCompanyId,
                this.allCompanies
            ).then((res:any) => {
                if(res.length > 0){
                    res = res.map(function(item){
                        return {
                            ...item,
                            template_description: item.template.description,
                            company_name: item['company']['name'],
                            template_name: item.template.name,
                            has_dayrange: item.template.has_dayrange
                        }
                    })
                }
                this.setSuscriptions(res);
                this.pendingRequest(false);
            }).catch((err) => {
                this.setSuscriptions([]);
                this.pendingRequest(false);
                this.$_catchLoadingDialog({
                    response: err.response.data || {},
                    alternative_msg: 'No se pudo obtener la lista de suscripciones'
                })
                
            })
        }
    }


    checkboxClicked(item: ActiveReports){
        this.rowToDeactivate = item;
        let data: ReportActivation[] = [{
            report_type: item.template.report_type,
            company_id: item.company.id,
        }]
        if(!item.is_active){
            this.showDeactivateAlert(data, item);
        }else{
            this.activateReport(data, item);
        }
    }

    showDeactivateAlert(deactivateConfig: Array<ReportActivation>, rowToDeactivate: ActiveReports){
        this.confirmationDelete = true;
        this.deleteModalTitle = 'Desactivar reporte';
        this.deleteBody = '¿Está seguro que desea desactivar el reporte?';
        this.deactivateConfig = deactivateConfig;
        this.rowToDeactivate = rowToDeactivate;
    }

    deactivateReport(config: Array<ReportActivation>, rowInfo: ActiveReports){
        let self = this;
        this.pendingRequest(true);
        ReportsServices.deactivateReports(
            config
        ).then((res) => {
            this.$_showAddPointOfInterest(res.message);
            this.getActiveReports();
        }).catch((err) => {
            this.$set(this.rowToDeactivate as ActiveReports, 'is_active', true);
            this.$_catchLoadingDialog({
                response: err.response.data || {},
                alternative_msg: 'No se pudo desactivar el reporte'
            })
        }).finally(() => {
            this.pendingRequest(false);
        })
    }


    activateReport(config: Array<ReportActivation>, rowInfo: ActiveReports){
        let self = this;
        this.pendingRequest(true);
        ReportsServices.activateReports(
            config
        ).then((res) => {
            this.$_showAddPointOfInterest(res.message);
            this.getActiveReports();
        }).catch((err) => {
            this.$set(this.rowToDeactivate as ActiveReports, 'is_active', false);
            this.$_catchLoadingDialog({
                response: err.response.data || {},
                alternative_msg: 'No se pudo activar el reporte'
            })
        }).finally(() => {
            this.pendingRequest(false);
        })
    }


    mounted() {
        this.getTemplatesList();
    }

    getTemplatesList(){
        ReportsServices.getTemplatesList()
        .then((res) => {
            this.templatesList = res['templates']
            this.templatesList = this.templatesList.sort(sortObjectByPropertyName('description'));
            // console.log("res", res);
        }).catch((err) => {
            this.templatesList = [];
            this.$_showHistoricalError('No se pudo obtener la lista de templates');
            // console.log("res", err);
        })
    }
}
